export const enum PriceMaskType {
  Cheap = 'cheap',
  Moderate = 'moderate',
  Expensive = 'expensive',
}
